import axios from 'axios'

const state = {
  articles: [],
  articlesLoading: false,
  article: null,
  articleLoading: false
}

const actions = {
  /**
   * Service pour récupérer les articles d'une famille.
   * @param {*} param0 
   * @returns 
   */
  getArticles({
    commit,
    dispatch
  }, info) {
    return new Promise((resolve, reject) => {
      commit('setArticlesLoading', true)
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.get(process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
      }).then(response => {
        // Ajout du lien de la photo
        response.data.forEach(article => {
          if (article.photo_1) {
            article.photoLink1 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + article.id + '/photo/1'
          }
          if (article.photo_2) {
            article.photoLink2 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + article.id + '/photo/2'
          }
          if (article.photo_3) {
            article.photoLink3 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + article.id + '/photo/3'
          }
        })
        commit('setArticles', response.data)
        commit('setArticlesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setArticlesLoading', false)
        reject(error)
      })
    })
  },

  /**
   * Service pour récupérer les articles actifs d'une famille.
   * @param {*} param0 
   * @returns 
   */
  getArticlesActifs({
    commit,
    dispatch
  }, info) {
    return new Promise((resolve, reject) => {
      commit('setArticlesLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/actifs', {
        headers: {
          Accept: 'application/json'
        },
      }).then(response => {
        // Ajout du lien de la photo
        response.data.forEach(article => {
          if (article.photo_1) {
            article.photoLink1 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + article.id + '/photo/1'
          }
          if (article.photo_2) {
            article.photoLink2 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + article.id + '/photo/2'
          }
          if (article.photo_3) {
            article.photoLink3 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + article.id + '/photo/3'
          }
        })
        commit('setArticles', response.data)
        commit('setArticlesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setArticlesLoading', false)
        reject(error)
      })
    })
  },

  /**
   * Service pour récupérer un article.
   * @param {*} param0 
   * @returns 
   */
  getArticle({
    commit,
    dispatch
  }, info) {
    return new Promise((resolve, reject) => {
      commit('setArticleLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + info.prodId, {
        headers: {
          Accept: 'application/json'
        },
      }).then(response => {
        if (response.data.photo_1) {
          response.data.photoLink1 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + response.data.id + '/photo/1'
        }
        if (response.data.photo_2) {
          response.data.photoLink2 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + response.data.id + '/photo/2'
        }
        if (response.data.photo_3) {
          response.data.photoLink3 = process.env.VUE_APP_API_URL + '/categories/' + info.catId + '/familles/' + info.famId + '/articles/' + response.data.id + '/photo/3'
        }
        commit('setArticle', response.data)
        commit('setArticleLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setArticleLoading', false)
        reject(error)
      })
    })
  },
  /**
   * Service pour créer un article.
   * @param {*} param0 
   * @returns 
   */
  createArticle({
    commit,
    dispatch
  }, famille) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.post(process.env.VUE_APP_API_URL + '/categories/' + famille.catId + '/familles/' + famille.famId + '/articles', famille.formData, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * Service pour modifier un article.
   * @param {*} param0 
   * @returns 
   */
  updateArticle({
    commit,
    dispatch
  }, article) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.post(process.env.VUE_APP_API_URL + '/categories/' + article.catId + '/familles/' + article.famId + '/articles/' + article.id, article.formData, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * Service pour appliquer une promotion globale.
   * @param {*} param0 
   * @returns 
   */
  applyGlobalPromotion({
    commit,
    dispatch
  }, info) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.put(process.env.VUE_APP_API_URL + '/articles/promotion', info, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * Service pour supprimer un article.
   * @param {*} param0 
   * @returns 
   */
  deleteArticle({
    commit,
    dispatch
  }, article) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.delete(process.env.VUE_APP_API_URL + '/categories/' + article.catId + '/familles/' + article.famId + '/articles/' + article.id, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}


const getters = {
  articles: state => state.articles,
  articlesLoading: state => state.articlesLoading,
  article: state => state.article,
  articleLoading: state => state.articleLoading
}

const mutations = {
  setArticles(state, articles) {
    state.articles = articles
  },
  setArticlesLoading(state, articlesLoading) {
    state.articlesLoading = articlesLoading
  },
  setArticle(state, article) {
    state.article = article
  },
  setArticleLoading(state, articleLoading) {
    state.articleLoading = articleLoading
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}